import { DocumentRecord } from "@models/annual-statements/document-record";
import { AsicStatus } from "@models/documents/asic-status.enum";
import { Document } from "@models/documents/document";

export function isAllowedToDeleteDocuments(documentRecords: (DocumentRecord | Document)[]): boolean {
  const forbidDocumentsStatuses: AsicStatus[] = [
    AsicStatus.Pending,
    AsicStatus.WaitingForASIC,
    AsicStatus.Validated,
    AsicStatus.ManualProcessing,
    AsicStatus.MarkedAsLodged,
    AsicStatus.Lodged,
  ];

  return documentRecords.length > 0
    && !documentRecords.some((x) => forbidDocumentsStatuses.includes(x.asicStatus));
}
